<template>
  <Teleport to="body">
    <div v-if="isOpen" class="modal-overlay">
      <div class="modal-content">
        <div class="modal-header">
          <h3 class="modal-title">{{ t('modal.title') }}</h3>
          <button @click="closeModal" class="close-button" aria-label="Fermer">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>  
          </button> 
        </div>
        <p class="modal-subtitle">{{ t('modal.subtitle') }}</p>
        <form @submit.prevent="handleSubmit" class="subscribe-form">
          <input 
            v-model="email"   
            type="email" 
            :placeholder="t('modal.placeholder')" 
            required
            class="email-input"
          >
          <button type="submit" class="subscribe-button">
            {{ t('modal.subscribe_button') }}
          </button>
        </form>
        <p class="privacy-note">{{ t('modal.privacy_note') }}</p>
      </div>
    </div>
  </Teleport>
</template>

<script setup>
import { ref, defineEmits } from 'vue';
import { useI18n } from 'vue-i18n';
import { useDataStore } from '@/stores/mainStore'; // Import the store

const { t } = useI18n(); // Destructure t for translation
const emit = defineEmits(['close']);
const isOpen = ref(true);
const email = ref('');
const store = useDataStore(); // Initialize the store

const closeModal = () => {
  isOpen.value = false;
  emit('close');
};

const handleSubmit = async () => {
  await store.subscribeUser(email.value); // Call the store action
  closeModal();
};
</script>
  
  <style scoped>
  .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
  }
  
  .modal-content {
    background-color: #ffffff;
    border-radius: 12px;
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
    max-width: 90%;
    width: 400px;
    overflow: hidden;
    animation: fadeIn 0.3s ease-out;
  }
  
  @keyframes fadeIn {
    from { opacity: 0; transform: translateY(-20px); }
    to { opacity: 1; transform: translateY(0); }
  }
  
  .modal-header {
    background-color: #3498db;
    color: #ffffff;
    padding: 20px;
    position: relative;
  }
  
  .modal-title {
    font-size: 24px;
    font-weight: bold;
    margin: 0;
    padding-right: 24px;
  }
  
  .close-button {
    position: absolute;
    right: 15px;
    top: 15px;
    background: none;
    border: none;
    cursor: pointer;
    color: #ffffff;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: transform 0.2s ease;
  }
  
  .close-button:hover {
    transform: scale(1.1);
  }
  
  .modal-subtitle {
    font-size: 16px;
    color: #555;
    margin: 15px 20px;
    text-align: center;
  }
  
  .subscribe-form {
    padding: 0 20px 20px;
  }
  
  .email-input {
    width: 100%;
    padding: 12px 15px;
    margin-bottom: 15px;
    border: 1px solid #e0e0e0;
    border-radius: 6px;
    font-size: 16px;
    transition: border-color 0.2s ease;
  }
  
  .email-input:focus {
    outline: none;
    border-color: #3498db;
  }
  
  .subscribe-button {
    width: 100%;
    padding: 12px;
    background-color: #2ecc71;
    color: #ffffff;
    border: none;
    border-radius: 6px;
    font-size: 16px;
    font-weight: bold;
    cursor: pointer;
    transition: background-color 0.2s ease, transform 0.1s ease;
  }
  
  .subscribe-button:hover {
    background-color: #27ae60;
  }
  
  .subscribe-button:active {
    transform: scale(0.98);
  }
  
  .privacy-note {
    text-align: center;
    font-size: 12px;
    color: #7f8c8d;
    margin: 15px 0 0;
    padding: 0 20px 20px;
  }
  </style>
  
  